<app-breadcrumb [master]="'Administracja'" [parentName]="'Licencje'" [name]="'Użytkownicy'"></app-breadcrumb>
<mat-tab-group   (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-user-licenses-details-view *ngIf="!modify" [user]="user" (modifyClicked)="modify = true" ></app-user-licenses-details-view>
  </mat-tab>
</mat-tab-group>
